export default {
    alternative: "Alternativa",
    alternatives_justification: "Alternativas com justificativa",
    alternatives: "Alternativas",
    answer: "Resposta",
    answers: "Respostas",
    basic_data: "Dados básicos",
    clients: "Clientes",
    dissertative: "Dissertativa",
    end_date: "Data de término",
    justification: "Justificativa",
    justify: "Justifique",
    mandatory: "Obrigatória",
    multiple_choices_justification: "Multipla escolha com justificativa",
    multiple_choices: "Multipla escolha",
    no_questions_are_defined: "Não existem perguntas definidas",
    no_survey_avaliable: "Nenhuma pesquisa disponível",
    optional: "Opcional",
    owners: "Responsáveis",
    permission: "Permissão",
    permissions: "Permissões",
    question_save_error: "Erro ao salvar pergunta",
    question_save_success: "Pergunta salva com sucesso",
    question_type: "Tipo de questão",
    question: "Questão",
    questions_quantity: "Quantidade de perguntas",
    questions: "Perguntas",
    score: "Pontos",
    select_at_least_one_option: "Selelcione ao menos uma opção",
    start_date: "Data de início",
    survey_published_success: "Pesquisa publicada com sucesso",
    survey_save_error: "Erro ao salvar pesquisa",
    survey_save_success: "Pesquisa salva com sucesso",
    survey_type: "Tipo de pesquisa",
    survey_unpublished_success: "Pesquisa despublicada com sucesso",
    survey_people_answered_quantity: "Quantidade de pessoas que responderam",
    survey_people_answered_percentage: "Respostas (%)",
    surveys: "Pesquisas",
    user_answers: "Respostas de usuários",
    survey_anonymous_results_label: "Essa pesquisa é anônima."
}
